/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDynamicContent = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 11v9l-16.587-.001 1.294 1.294-1.414 1.414L1.586 19l3.707-3.707 1.414 1.414-1.294 1.292L20 18v-7zm-6 2v2H8v-2zm2.707-11.707L22.414 5l-3.707 3.707-1.414-1.414 1.292-1.294L4 6v7H2V4l16.585-.001-1.292-1.292zM16 9v2H8V9z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgDynamicContent as DynamicContent };
